import axiosInstance from '../helpers/axios';
import { handleError, handleSuccess, waitAndReload } from '../helpers/utils';
import { types } from '../types/types';
import { getToken } from './auth';

// Dispatch set clients
export const setClients = (data) => ({
	type: types.setClients,
	payload: data,
});

// Dispatch clean clients
export const cleanClients = () => ({
	type: types.cleanClients,
});

// Register client
export const registerClient = async (data) => {
	return await axiosInstance({
		method: 'post',
		url: '/api/client/',
		data: data,
	});
};

// Update client
export const updateClient = async (id, data) => {
	const token = getToken();
	return await axiosInstance({
		method: 'put',
		url: `/api/client/${id}`,
		headers: { Authorization: 'Bearer ' + token },
		data: data,
	});
};

// Get client info
export const getClientInfo = async (id) => {
	const token = getToken();
	return await axiosInstance({
		method: 'get',
		url: `/api/client/${id}`,
		headers: { Authorization: 'Bearer ' + token },
	});
};

// Get all clients
export const getClients = async (endpoint = null, pageSize = 10) => {
	const token = getToken();
	return await axiosInstance({
		method: 'get',
		url: endpoint
			? endpoint
			: `/api/client/?ordering=-created_at&page_size=${pageSize}`,
		headers: { Authorization: 'Bearer ' + token },
	});
};

// Delete client
export const deleteClient = (id) => {
	return () => {
		// Get token if authenticated
		const token = getToken();
		axiosInstance({
			method: 'delete',
			url: `/api/client/${id}`,
			headers: { Authorization: 'Bearer ' + token },
		})
			.then(() => {
				handleSuccess('Cliente eliminado correctamente.');
				waitAndReload();
			})
			.catch((error) => {
				handleError(error, 'No se pudo eliminar al cliente.');
			});
	};
};

// Get client address
export const getClientAddress = (client) => {
	return [
		client?.address_shipping,
		client?.colony_shipping,
		client?.municipality_shipping,
		client?.zip_code_shipping,
	]
		.filter(Boolean) // Remove empty fields
		.join(', ');
};
